export class Method {
  visibility: string;
  returnType: string;
  name: string;
  argsType: string[];

  constructor(visibility: string, returnType: string, name: string, argsType: string[]) {
    this.visibility = visibility;
    this.returnType = returnType;
    this.name = name;
    this.argsType = argsType;
  }

  toUmlString(): string {
    let umlString = `${this._getVisibilitySymbol()} ${this.name}(${this.argsType.join(', ')})`;
    if (this.returnType !== '') umlString += `: ${this.returnType}`;
    return umlString;
  }

  private _getVisibilitySymbol(): string {
    if (this.visibility === 'private') return '-';
    if (this.visibility === 'public') return '+';
    return '#';
  }
}
